import { render } from "./RewardDetail.vue?vue&type=template&id=545334a2&scoped=true"
import script from "./RewardDetail.vue?vue&type=script&lang=js"
export * from "./RewardDetail.vue?vue&type=script&lang=js"

import "./RewardDetail.vue?vue&type=style&index=0&id=545334a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545334a2"]])

export default __exports__